window.addEventListener("load", function () {
  if ($("#swiperCharacter").length > 0) {
    const mainSwiper = new Swiper("#swiperCharacter", {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      effect: "fade",
      loop: true,
      touchStartPreventDefault: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
});
